// Setup the prefilter
cv.setupPrefilter = function(key, value){
  var key = encodeURIComponent(key);
  var value = encodeURIComponent(value);

  $.ajaxPrefilter(function (options, originalOptions, jqXHR) {
    // Set headers
    if(key == 'api_key'){
      if(!options.beforeSend){
        jqXHR.setRequestHeader('Apikey', value);
      }
      return;
    }
    if(key == 'csrf'){
      if(!options.beforeSend){
        jqXHR.setRequestHeader('X-CSRF-TOKEN', value);
      }
      return;
    }
    
    // Setup key/values
    var url_components = options.url.split('?', 2);
    if(url_components.length > 1){
      // De-param the string
      var query_params = $.deparam(url_components[1]);

      // Add the new parameter
      if(value != '' && !options.beforeSend){
        var tmp = {};
        tmp[key] = value;
        _.extend(query_params, tmp);
      }else{
        if(_.has(query_params, key)){
          delete query_params[key];
        }
      }

      // Convert back to string
      if(_.size(query_params) > 0){
        options.url = url_components[0] + '?' + $.param(query_params);
      }
    }else{
      if(value != '' && !options.beforeSend){
        options.url = options.url + '?' + key + '=' + value;
      }
    }
  });
};
